import { NamedFees, OrderSummaryItems } from './../models/order-summary-items.model';
import { Injectable, OnDestroy, OnInit } from '@angular/core';
import * as Store from '@core/redux/stores';
import { ProxyService } from '@core/services/proxy.service';
import { ManagePaymentRequest } from '@features/account/models';
import { TimePicker } from '@features/ordering/models';
import { ApiRoutes } from '@shared/models/configs/api.endpoints';
import { Subscription, BehaviorSubject } from 'rxjs';
import { DeliveryAddress, DeliveryQuoteRequest, DeliveryFee, LocationsEntity, PickupType, FeeCalculationType, Order } from '@core/redux/stores';
import * as _ from 'lodash-es';
import { TaxCalculatorService } from '@features/ordering/services/tax-calculator.service';
import { TaxRoundingType } from '@features/ordering/utilties/enums/tax-calculator.utility';
import { Router } from '@angular/router';
import { environment } from '@environments/environment';
import { UserPaymentProvider } from '@app/core/models/payment-service-models.model';
import { CheckTimeUtility } from '@app/features/ordering/utilties/check-time-utility';
import moment from 'moment-timezone';
import { UtilitiesService, ConfirmModalService } from '@app/core/services';
import { Constants } from '@app/core/constants/core.constants';
import { PaymentTypeString } from '@app/core/models/payment-service-models.model';

@Injectable()
export class FinalCheckoutService implements OnInit, OnDestroy {
  showPickup: boolean;
  showLocation: boolean;
  showPayment: boolean;
  showOrderSummary: boolean;
  showCustomerDetails: boolean;
  pickupMethod: number;
  showAddpayment: boolean;
  showPaymenterror: boolean;
  paymentErrorMsg: '';
  disablePlaceOrder: boolean;
  pickUpTimeError: boolean;
  showtimepicker: boolean;
  showpickupMethod: boolean;
  showDeliveryAddress: boolean;
  pickUpMethodError: boolean;
  pickUpTimeErrMsg = 'Please choose an available pickup time.';
  pickupMethodErrMsg: 'Please choose an available pickup method.';
  showmethodpicker: boolean;
  isShowPlaceOrder: boolean;
  isShowDetails: boolean;
  isLoading: boolean;
  showGiftCarderror: boolean;
  balance: number;
  cardList = new Array<ManagePaymentRequest>();
  changeinfo: boolean;

  disableTimepicker: boolean;
  disablePickUpMethod: boolean;

  public selectedTime: TimePicker = new TimePicker();
  public orderPaymentInfo: Store.OrderGuestPaymentInfo;
  public selectedCard: ManagePaymentRequest;
  giftcard: ManagePaymentRequest;
  appleGooglePay: ManagePaymentRequest;
  public submitOrderRequest: Store.SubmitOrderRequest;
  public submitRequest: Store.SubmitOrderRequest;
  public confirmAndPay: Store.ConfirmAndPay;
  public cardBrand: string;
  public cardLast4: string;
  public save_future_payment = false;
  public previousOrder: Store.UserOrderInfo;
  public previousOrderRecipes: Store.Recipe[];
  checkoutPaymentRequest: ManagePaymentRequest;
  private subscriptions = new Subscription();
  public originalcardList = new Array<ManagePaymentRequest>();
  showtimepickerSummary: boolean;
  deliveryQuote: Store.DeliveryQuote;
  public deliveryAddress: DeliveryAddress;
  private tipSetSubject = new BehaviorSubject<boolean>(false);
  public isTipSet$ = this.tipSetSubject.asObservable();
  private TAX_INCREMENT = 0.01;
  automaticDeliveryLocation: boolean;
  public paymentProvider: UserPaymentProvider;
  constructor(private proxyService: ProxyService,
    private taxCalculator: TaxCalculatorService,
    private router: Router,
    private confirmModalService: ConfirmModalService
  ) { }

  ngOnInit() {
  }

  pickupTimeService(locationID, query, pickupMethod: any = null, isImmediate = true) {
    let pickupTimeEndpoint = ApiRoutes.LOCATIONS + locationID + '/order-pickup-options?orderTotal=' + query;
    if (pickupMethod) {
      pickupTimeEndpoint += '&selectedPickupType=' + pickupMethod;
    }
    if (isImmediate) {
      pickupTimeEndpoint += '&isImmediate=' + isImmediate;
    }
    return this.proxyService.httpGet(pickupTimeEndpoint);
  }
  getAvailablePickupMethods(pickupTimes: TimePicker[]): number[] {
    const availablePickupMethodCollection = pickupTimes.map(pt => pt.availablePickupTypes).filter(r => r.length > 0);
    const availablePickupMethods = new Set([].concat(...availablePickupMethodCollection));
    return Array.from(availablePickupMethods);
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  requestQuote(locationId: number, deliveryAddress: DeliveryAddress, subtotal: number, deliveryDropOffTime: string = null, isOversize = false) {
    const deliveryQuoteEndpoint = ApiRoutes.DELIVERY_QUOTE;
    const deliveryQuoteRequest: DeliveryQuoteRequest = {
      dropoffAddress: deliveryAddress,
      deliveryTimeUtc: deliveryDropOffTime,
      pickupLocationId: locationId,
      orderSubtotal: subtotal,
      isOversize: isOversize
    };
    return this.proxyService.httpPost(deliveryQuoteEndpoint, deliveryQuoteRequest);
  }

  calculateFee(deliveryFee: DeliveryFee, subTotal: number): number {
    const fee = _.cloneDeep(deliveryFee);
    let feeAmount = null;
    if (fee && fee.discounts.length > 0) {
      fee.discounts.forEach(d => {
        if (!d.minimumSubTotal) {
          d.minimumSubTotal = 0;
        }
        if (subTotal >= d.minimumSubTotal && (subTotal <= d.maximumSubTotal || !d.maximumSubTotal)) {
          feeAmount = fee.amount - (d.discountAmount ? d.discountAmount : 0);
        }
      });
      if (feeAmount != null) {
        return feeAmount;
      } else {
        return fee.amount;
      }
    } else {
      return fee.amount;
    }
  }

  calculateOrderSummaryItems(order: Store.Order, location: LocationsEntity, includeTip = true): OrderSummaryItems {
    let subTotal = 0; let tax = 0; let orderTotal = 0; let tip = null; let serviceFee = null; let deliveryFee = null; let namedFees = null;
    let nonTaxableSubtotal = 0;
    if (order && (order.childRecipes || !environment.features.deliveryFrontOfFlow)) { // Addl check added for delivery FoF
      order.childRecipes.forEach(
        childrec => subTotal += childrec.totalPrice * childrec.quantity);
      let effectiveUtc = this?.selectedTime?.startTimeUtc ? moment.utc(this.selectedTime.startTimeUtc) : moment().utc();
      const chargeableEnterpriseIds = new Set(['9990', '9991', '9993', '9994']);
      const deliveryOnlyEnterpriseIds = new Set(['9991', '9994']);
      const displayNameByEnterpriseId: Record<string, string> = {
        '9990': 'PIF',
        '9993': 'PIF',
        '9991': 'Retail Delivery Fee',
        '9994': 'Retail Delivery Fee'
      };
      namedFees = location?.fees
                          ?.filter(f => CheckTimeUtility.isUTCTimeInBetweenRange(effectiveUtc, f?.effectiveUtc, f?.expiryUtc) && (!f.pickupTypes?.length || f.pickupTypes.includes(order.pickupType)))
                          ?.filter(f => !f?.enterpriseId || chargeableEnterpriseIds.has(String(f.enterpriseId)))
                          ?.filter(f => !f?.enterpriseId || !deliveryOnlyEnterpriseIds.has(String(f.enterpriseId)) || order.pickupType === PickupType.Delivery)
                          ?.map(f => <NamedFees>{
                            name: displayNameByEnterpriseId[String(f?.enterpriseId)] || f?.name,
                            fee: this.calculateFeeItemByType(f, subTotal),
                            taxable: f?.taxable ?? false
                          });       
        
      let taxableSubtotal = subTotal;
      const taxRate = this.taxCalculator.calculateTaxRate(location);
      const isTaxIncluded = this.taxCalculator.IsTaxIncluded(taxRate.taxRoundingType);
      this.pickupMethod = order.pickupType;
      this.deliveryQuote = order.deliveryQuote;
      // Get the Delivery calculations out of the way
      if (this.pickupMethod === PickupType.Delivery && this.deliveryQuote) {

        serviceFee = this.calculateFee(this.deliveryQuote.serviceFee, subTotal);
        deliveryFee = this.calculateFee(this.deliveryQuote.deliveryFee, subTotal);
        const isTipTaxable = this.deliveryQuote.isTipTaxable ?? this.deliveryQuote.tipFee?.isTaxable ?? false;
        if (order.tipAmount !== null &&
          order.tipAmount !== undefined) {
          tip = order.tipAmount;
        } else {
          tip = null;
        }
        let tipTaxComponent = 0;

        if (isTaxIncluded && (this.deliveryQuote.deliveryFee.isTaxable || this.deliveryQuote.serviceFee.isTaxable || (includeTip && tip !== null && isTipTaxable))) {
          const totalTaxableDeliveryCosts = (this.deliveryQuote.deliveryFee.isTaxable ? this.deliveryQuote.deliveryFee.amount : 0)
            + (this.deliveryQuote.serviceFee.isTaxable ? this.deliveryQuote.serviceFee.amount : 0)
            + (includeTip && tip !== null && isTipTaxable ? tip : 0);
          const totalDeliveryCostTaxes =
            this.taxCalculator.CalculateTax(totalTaxableDeliveryCosts, taxRate.taxRate, TaxRoundingType.RoundToEven);
          let serviceFeeTaxComponent = 0; let deliveryFeeTaxComponent = 0;
          if (this.deliveryQuote.serviceFee.isTaxable) {
            serviceFeeTaxComponent = this.taxCalculator.CalculateTax(serviceFee, taxRate.taxRate, TaxRoundingType.RoundToEven);
            serviceFee += serviceFeeTaxComponent;
          }
          if (this.deliveryQuote.deliveryFee.isTaxable) {
            deliveryFeeTaxComponent = this.taxCalculator.CalculateTax(deliveryFee, taxRate.taxRate, TaxRoundingType.RoundToEven);
            deliveryFee += deliveryFeeTaxComponent;
          }
          if (includeTip && tip !== null && isTipTaxable) {
            tipTaxComponent = this.taxCalculator.CalculateTax(tip, taxRate.taxRate, TaxRoundingType.RoundToEven);
          }
          let individualDeliveryCostTaxes = serviceFeeTaxComponent + deliveryFeeTaxComponent + tipTaxComponent;
          while (individualDeliveryCostTaxes < totalDeliveryCostTaxes) {
            if (this.deliveryQuote.deliveryFee.isTaxable) {
              deliveryFeeTaxComponent += this.TAX_INCREMENT;
              individualDeliveryCostTaxes += this.TAX_INCREMENT;
              deliveryFee += this.TAX_INCREMENT;
            }
            if (individualDeliveryCostTaxes >= totalDeliveryCostTaxes) {
              break;
            }
            if (this.deliveryQuote.serviceFee.isTaxable) {
              serviceFeeTaxComponent += this.TAX_INCREMENT;
              individualDeliveryCostTaxes += this.TAX_INCREMENT;
              serviceFee += this.TAX_INCREMENT;
            }
            if (individualDeliveryCostTaxes >= totalDeliveryCostTaxes) {
              break;
            }
            if (includeTip && tip !== null && isTipTaxable) {
              tipTaxComponent += this.TAX_INCREMENT;
              individualDeliveryCostTaxes += this.TAX_INCREMENT;
            }
          }
        }
        if (this.deliveryQuote.serviceFee.isTaxable) {
          taxableSubtotal += serviceFee;
        } else {
          nonTaxableSubtotal += serviceFee;
        }
        if (this.deliveryQuote.deliveryFee.isTaxable) {
          taxableSubtotal += deliveryFee;
        } else {
          nonTaxableSubtotal += deliveryFee;
        }
        if (includeTip && tip !== null) {
          if (isTipTaxable) {
            taxableSubtotal += tip;
            if (isTaxIncluded) {
              tax += tipTaxComponent;
            }
          } else {
            nonTaxableSubtotal += tip;
          }
        }
      }


      // Named Fees section
      ({ taxableSubtotal, nonTaxableSubtotal } = this.updateNamedFees(namedFees, isTaxIncluded, taxRate, taxableSubtotal, nonTaxableSubtotal));
      if (!isTaxIncluded) {
        tax = this.taxCalculator.CalculateTax(taxableSubtotal, taxRate.taxRate, taxRate.taxRoundingType);
      }
      orderTotal = this.taxCalculator.RoundAwayFromZero(taxableSubtotal + nonTaxableSubtotal + tax, 2);

    }
    const orderSummaryItems: OrderSummaryItems = {
      tax: tax,
      subTotal: subTotal,
      orderTotal: orderTotal,
      tip: tip,
      deliveryFee: deliveryFee,
      serviceFee: serviceFee,
      namedFees: namedFees
    };
    return orderSummaryItems;
  }

  private calculateFeeItemByType(f: Store.LocationFee, subTotal: number): number {
    switch (f.feeCalculationType) {
      case FeeCalculationType.Percentage:
        return this.taxCalculator.RoundAwayFromZero(f?.value / 100 * subTotal, 2);        
      case FeeCalculationType.Flat:
          return f?.value;
      default:
        return 0;
    }
  }

  private updateNamedFees(namedFees: any, isTaxIncluded: boolean, taxRate: Store.TaxRatesEntity, taxableSubtotal: number, nonTaxableSubtotal: number) {
    namedFees?.forEach(n => {
      if (n.taxable) {
        if (isTaxIncluded) {
          n.fee += this.taxCalculator.CalculateTax(n.fee, taxRate.taxRate, TaxRoundingType.RoundToEven);
        }
        taxableSubtotal += n.fee;
      }
      else {
        nonTaxableSubtotal += n.fee;
      }
    });
    return { taxableSubtotal, nonTaxableSubtotal };
  }

  public navigateToDeliveryAddressScreen() {
    this.showDeliveryAddress = true;
    this.isShowDetails = false;
    this.showtimepickerSummary = false;
    this.showmethodpicker = false;
    this.isShowDetails = false;
    this.isShowPlaceOrder = false;
    this.showOrderSummary = false;
  }

  public isTipSet(status: boolean) {
    this.tipSetSubject.next(status);
  }

  goToOrderStatus(isUserLoggedIn: Boolean) {
    if (isUserLoggedIn) {
      this.router.navigate(['/ordering/orderstatus'], { queryParams: 
        UtilitiesService.generateQueryParams([Constants.ORDER_ID], [this.previousOrder.orderNumber])});
    } else {
      this.router.navigate(['/ordering/orderstatus']);
    }
  }
  public doesOrderHaveOversizeItem(order: Order): boolean {
    if(order?.childRecipes?.length) {
      return order.childRecipes.some(r => r.isOversize);
    }
    return false;
  }


  public isCardExpired(card: ManagePaymentRequest): boolean {
    if (!card) {
      return false;
    }
    // Use the isExpired flag if it's already set
    if (card.isExpired !== undefined && card.isExpired !== null) {
      return card.isExpired;
    }
    // Otherwise, calculate it using the utility method
    return CheckTimeUtility.isCardExpired(card.expirationMonth, card.expirationYear);
  }

  public checkAndShowExpiredCardModal(isUserLoggedIn: boolean): boolean {
    if (this.selectedCard?.paymentType === PaymentTypeString.Card && this.isCardExpired(this.selectedCard)) {
      this.showExpiredCardModal(isUserLoggedIn);
      return true;
    }
    return false;
  }

  private showExpiredCardModal(isUserLoggedIn: boolean): void {
    this.confirmModalService.show(
      'Expired Card',
      '',
      'It looks like the card information entered is incorrect. Please verify and update your payment method.',
      'EDIT SELECTED CARD',
      '',
      'Nevermind, cancel',
      true,
      'expiredCardEdit',
      '',
      'expiredCardCancel'
    );
  }

  public handleExpiredCardEdit(isUserLoggedIn: boolean): void {
    if (isUserLoggedIn) {
      this.showAddpayment = true;
      this.isShowPlaceOrder = false;
    } else {
      this.router.navigate(['/ordering/checkout/payment'], { queryParams: 
        UtilitiesService.generateQueryParams([Constants.RETURN_URL], ['/order-review'])});
    }
  }
}
